export const users = [
  {
    id: "user001",
    name: "Γιάννης Παπαδόπουλος",
    email: "giannis@example.com",
    password: "hashedpassword",
    role: "customer",
    phone: "6987654321",
    loyaltyPoints: 120,
    favoriteRestaurants: ["resto006", "resto007", "resto008", "resto009"],
    preferredMenus: ["menu001"],
    preferredCuisines: ["Vegan", "Ασιατική"],
    newsletterSubscribed: true,
    profileImage: "/images/mobile1.jpg",
    createdAt: "2024-01-01T12:00:00Z",
    updatedAt: "2024-02-01T12:00:00Z",
  },
  {
    id: "owner001",
    name: "Νίκος Καραγιάννης",
    email: "nikos@example.com",
    password: "hashedpassword",
    role: "owner",
    phone: "6971234567",
    profileImage: "/images/mobile1.jpg",
    createdAt: "2023-12-15T12:00:00Z",
    updatedAt: "2024-02-01T12:00:00Z",
  },
];

export const purchasedCoupons = [
  {
    userId: "user001",
    couponId: "coupon003",
    purchasedAt: "2024-06-15T11:30:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon002",
    purchasedAt: "2024-07-10T09:20:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon003",
    purchasedAt: "2024-06-15T11:30:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon002",
    purchasedAt: "2024-07-10T09:20:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon003",
    purchasedAt: "2024-06-15T11:30:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon005",
    purchasedAt: "2024-07-10T09:20:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon003",
    purchasedAt: "2024-06-15T11:30:00Z",
  },
  {
    userId: "user001",
    couponId: "coupon004",
    purchasedAt: "2024-07-10T09:20:00Z",
  },
];

export const restaurants = [
  {
    id: "resto006",
    ownerId: "owner001",
    name: "The Cozy Taverna",
    location: "Πλάκα, Αθήνα",
    address: {
      street: "Διονυσίου Αρεοπαγίτου 15",
      number: 15,
      postalCode: "10558",
      area: "Πλάκα",
    },
    coordinates: { lat: 37.9715, lng: 23.7265 },
    cuisine: "Ελληνική Παραδοσιακή",
    rating: 4.9,
    openingHours: { open: "11:00", close: "23:30" },
    totalTables: 18,
    tables: ["table034", "table035", "table036", "table037"],
    menu: [
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
    ],
    specialMenus: ["menu003"],
    photos: ["/images/mobile3.jpg"],
    happyHours: [
      { startTime: "15:00", endTime: "17:00", discountPercentage: 25 },
    ],
    coupons: ["coupon003"],
    contact: {
      phone: "+30 210 3210000",
      email: "info@cozytaverna.gr",
      socialMedia: {
        facebook: "https://facebook.com/cozytaverna",
        instagram: "https://instagram.com/cozytaverna",
      },
    },
    createdAt: "2024-03-10T10:00:00Z",
    updatedAt: "2024-04-10T14:00:00Z",
  },
  {
    id: "resto007",
    ownerId: "owner001",
    name: "Burger Joint Deluxe",
    location: "Γλυφάδα, Αθήνα",
    address: {
      street: "Λεωφ. Ποσειδώνος 81",
      number: 81,
      postalCode: "16675",
      area: "Γλυφάδα",
    },
    coordinates: { lat: 37.9407, lng: 23.7402 },
    cuisine: "Αμερικάνικη",
    rating: 4.6,
    openingHours: { open: "12:00", close: "00:00" },
    totalTables: 22,
    tables: ["table038", "table039", "table040", "table041", "table042"],
    mmenu: [
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
    ],
    specialMenus: ["menu001"],
    photos: ["/images/mobile1.jpg"],
    happyHours: [
      { startTime: "18:00", endTime: "20:00", discountPercentage: 15 },
    ],
    coupons: ["coupon001", "coupon004"],
    contact: {
      phone: "+30 210 8980000",
      email: "contact@burgerdeluxe.gr",
      socialMedia: {
        facebook: "https://facebook.com/burgerjointdeluxe",
        instagram: "https://instagram.com/burgerjointdeluxe",
      },
    },
    createdAt: "2024-03-20T11:00:00Z",
    updatedAt: "2024-04-20T15:00:00Z",
  },
  {
    id: "resto008",
    ownerId: "owner001",
    name: "Vegan Garden Bistro",
    location: "Εξάρχεια, Αθήνα",
    address: {
      street: "Καλλιδρομίου 70",
      number: 70,
      postalCode: "10682",
      area: "Εξάρχεια",
    },
    coordinates: { lat: 37.9842, lng: 23.7331 },
    cuisine: "Vegan",
    rating: 4.7,
    openingHours: { open: "13:00", close: "22:00" },
    totalTables: 15,
    tables: ["table043", "table044", "table045"],
    menu: [
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
    ],
    specialMenus: ["menu002"],
    photos: ["/images/mobile2.jpg"],
    happyHours: [],
    coupons: ["coupon002"],
    contact: {
      phone: "+30 210 3830000",
      email: "hello@vegangarden.gr",
      socialMedia: {
        facebook: "https://facebook.com/vegangardenbistro",
        instagram: "https://instagram.com/vegangardenbistro",
      },
    },
    createdAt: "2024-04-01T12:00:00Z",
    updatedAt: "2024-05-01T16:00:00Z",
  },
  {
    id: "resto009",
    ownerId: "owner001",
    name: "Seafood Paradise Grill",
    location: "Πειραιάς, Αθήνα",
    address: {
      street: "Ακτή Θεμιστοκλέους 18",
      number: 18,
      postalCode: "18537",
      area: "Πειραιάς",
    },
    coordinates: { lat: 37.9445, lng: 23.6458 },
    cuisine: "Θαλασσινά",
    rating: 4.8,
    openingHours: { open: "11:30", close: "00:30" },
    totalTables: 25,
    tables: ["table046", "table047", "table048", "table049", "table050"],
    menu: [
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
    ],
    specialMenus: ["menu003"],
    photos: ["/images/mobile3.jpg"],
    happyHours: [
      { startTime: "17:30", endTime: "19:30", discountPercentage: 20 },
    ],
    coupons: ["coupon005"],
    contact: {
      phone: "+30 210 4510000",
      email: "seafood@paradise.gr",
      socialMedia: {
        facebook: "https://facebook.com/seafoodparadise",
        instagram: "https://instagram.com/seafoodparadise",
      },
    },
    createdAt: "2024-04-15T10:30:00Z",
    updatedAt: "2024-05-08T14:30:00Z",
  },
  {
    id: "resto010",
    ownerId: "owner001",
    name: "Spicy Noodles Bar",
    location: "Μοναστηράκι, Αθήνα",
    address: {
      street: "Αθηνάς 12",
      number: 12,
      postalCode: "10551",
      area: "Μοναστηράκι",
    },
    coordinates: { lat: 37.9762, lng: 23.7248 },
    cuisine: "Ασιατική",
    rating: 4.5,
    openingHours: { open: "12:30", close: "23:00" },
    totalTables: 16,
    tables: ["table051", "table052", "table053", "table054"],
    menu: [
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
      "item025",
      "item026",
      "item027",
      "item028",
      "item029",
      "item030",
      "item031",
      "item032",
      "item033",
      "item034",
      "item035",
      "item036",
      "item037",
      "item038",
      "item039",
      "item040",
      "item041",
    ],
    specialMenus: ["menu001"],
    photos: ["/images/mobile1.jpg"],
    happyHours: [],
    coupons: ["coupon004"],
    contact: {
      phone: "+30 210 3250000",
      email: "spicy@noodles.gr",
      socialMedia: {
        facebook: "https://facebook.com/spicynoodlesbar",
        instagram: "https://instagram.com/spicynoodlesbar",
      },
    },
    createdAt: "2024-04-25T11:45:00Z",
    updatedAt: "2024-05-05T15:45:00Z",
  },
];

export const testimonials = [
  {
    id: "review021",
    message: "Υπέροχο φαγητό και εξαιρετική εξυπηρέτηση στο The Cozy Taverna!",
  },
  {
    id: "review022",
    message:
      "Τα burgers στο Burger Joint Deluxe είναι τα καλύτερα που έχω δοκιμάσει!",
  },
  {
    id: "review023",
    message:
      "Φανταστικές vegan επιλογές στο Vegan Garden Bistro, το συστήνω ανεπιφύλακτα!",
  },
  {
    id: "review024",
    message: "Φρέσκα και νόστιμα θαλασσινά στο Seafood Paradise Grill, άψογο!",
  },
  {
    id: "review025",
    message: "Τα noodles στο Spicy Noodles Bar ήταν πικάντικα και γευστικά!",
  },
];

export const menuItems = [
  {
    id: "item025",
    restaurantId: "resto006",
    name: "Χωριάτικη Σαλάτα",
    price: 7.5,
    category: "Ορεκτικά",
    description: "Φρέσκα ντομάτα, αγγούρι, κρεμμύδι, πιπεριές, ελιές και φέτα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item026",
    restaurantId: "resto006",
    name: "Μουσακάς",
    price: 12.0,
    category: "Κυρίως",
    description: "Κλασικό ελληνικό πιάτο με κιμά, μελιτζάνες και μπεσαμέλ.",
    discount: 15,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item027",
    restaurantId: "resto006",
    name: "Γιαούρτι με Μέλι και Καρύδια",
    price: 5.5,
    category: "Επιδόρπια",
    description: "Κρεμώδες γιαούρτι με ντόπιο μέλι και τραγανά καρύδια.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item028",
    restaurantId: "resto007",
    name: "Classic Cheeseburger",
    price: 8.5,
    category: "Κυρίως",
    description: "Ζουμερό μπιφτέκι με τυρί, μαρούλι, ντομάτα και σως.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item029",
    restaurantId: "resto007",
    name: "Onion Rings",
    price: 4.0,
    category: "Ορεκτικά",
    description: "Τραγανές ροδέλες κρεμμυδιού πανέ με σως μουστάρδας.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item030",
    restaurantId: "resto007",
    name: "Chocolate Milkshake",
    price: 6.0,
    category: "Ποτά",
    description: "Κρεμώδες milkshake σοκολάτας με σαντιγί.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item031",
    restaurantId: "resto007",
    name: "BBQ Bacon Burger",
    price: 9.5,
    category: "Κυρίως",
    description: "Μπιφτέκι με μπέικον, τυρί, BBQ σως και κρεμμύδι.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item032",
    restaurantId: "resto008",
    name: "Vegan Burger",
    price: 9.0,
    category: "Κυρίως",
    description:
      "Μπιφτέκι λαχανικών με αβοκάντο, μαρούλι, ντομάτα και vegan μαγιονέζα.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item033",
    restaurantId: "resto008",
    name: "Hummus with Pita",
    price: 6.5,
    category: "Ορεκτικά",
    description: "Κρεμώδης χούμους σερβιρισμένος με ζεστές πίτες.",
    discount: 10,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item034",
    restaurantId: "resto008",
    name: "Vegan Chocolate Cake",
    price: 7.0,
    category: "Επιδόρπια",
    description: "Λαχταριστό vegan κέικ σοκολάτας με γλάσο.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item035",
    restaurantId: "resto009",
    name: "Grilled Octopus",
    price: 18.0,
    category: "Κυρίως",
    description: "Φρέσκο χταπόδι στη σχάρα με λαδολέμονο και ρίγανη.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item036",
    restaurantId: "resto009",
    name: "Fried Calamari",
    price: 15.0,
    category: "Ορεκτικά",
    description: "Τραγανό καλαμαράκι τηγανητό με σως ταρτάρ.",
    discount: 5,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item037",
    restaurantId: "resto009",
    name: "Seafood Risotto",
    price: 16.5,
    category: "Κυρίως",
    description: "Κρεμώδες ριζότο με φρέσκα θαλασσινά και μυρωδικά.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item038",
    restaurantId: "resto009",
    name: "Greek Salad",
    price: 8.0,
    category: "Ορεκτικά",
    description:
      "Παραδοσιακή ελληνική σαλάτα με ντομάτα, αγγούρι, κρεμμύδι, ελιές και φέτα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item039",
    restaurantId: "resto010",
    name: "Pad Thai",
    price: 11.5,
    category: "Κυρίως",
    description:
      "Ταϊλανδέζικα noodles ρυζιού με tofu, αυγό, φιστίκια και λαχανικά σε σάλτσα tamarind.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item040",
    restaurantId: "resto010",
    name: "Spring Rolls",
    price: 5.0,
    category: "Ορεκτικά",
    description: "Τραγανά ρολάκια λαχανικών σε λεπτό φύλλο ρυζιού.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item041",
    restaurantId: "resto010",
    name: "Tom Yum Soup",
    price: 6.0,
    category: "Ορεκτικά",
    description:
      "Πικάντικη και ξινή ταϊλανδέζικη σούπα με γαρίδες, μανιτάρια και μυρωδικά.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item042",
    restaurantId: "resto006",
    name: "Σουβλάκι Χοιρινό",
    price: 9.0,
    category: "Κυρίως",
    description: "Ζουμερά κομμάτια χοιρινού σε πίτα με ντομάτα και τζατζίκι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item043",
    restaurantId: "resto006",
    name: "Σαγανάκι",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Τηγανητό τυρί με τραγανή κρούστα, σερβιρισμένο ζεστό.",
    discount: 5,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item044",
    restaurantId: "resto006",
    name: "Γαλακτομπούρεκο",
    price: 5.5,
    category: "Επιδόρπια",
    description: "Παραδοσιακό γλυκό με σιμιγδάλι και τραγανό φύλλο.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item045",
    restaurantId: "resto006",
    name: "Τσικουδιά",
    price: 3.0,
    category: "Ποτά",
    description: "Παραδοσιακό ελληνικό απόσταγμα από Κρήτη.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },

  {
    id: "item046",
    restaurantId: "resto007",
    name: "Loaded Fries",
    price: 5.5,
    category: "Ορεκτικά",
    description: "Πατάτες με τυρί, μπέικον και σως cheddar.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item047",
    restaurantId: "resto007",
    name: "Chicken Wings",
    price: 7.0,
    category: "Ορεκτικά",
    description: "Φτερούγες κοτόπουλου με καυτερή buffalo sauce.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item048",
    restaurantId: "resto007",
    name: "Vanilla Milkshake",
    price: 6.0,
    category: "Ποτά",
    description: "Γλυκό milkshake βανίλιας με σαντιγί και κερασάκι.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item049",
    restaurantId: "resto007",
    name: "Double Bacon Burger",
    price: 10.5,
    category: "Κυρίως",
    description: "Διπλό μπιφτέκι με μπέικον, cheddar και BBQ σως.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },

  {
    id: "item050",
    restaurantId: "resto008",
    name: "Falafel Bowl",
    price: 8.0,
    category: "Κυρίως",
    description: "Νόστιμα φαλάφελ με κινόα, λαχανικά και ταχίνι.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item051",
    restaurantId: "resto008",
    name: "Vegan Cheese Platter",
    price: 9.5,
    category: "Ορεκτικά",
    description: "Ποικιλία vegan τυριών με συνοδευτικά.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item052",
    restaurantId: "resto008",
    name: "Matcha Latte",
    price: 4.5,
    category: "Ποτά",
    description: "Ρόφημα matcha με φυτικό γάλα και αφρόγαλα.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item053",
    restaurantId: "resto008",
    name: "Raw Energy Balls",
    price: 3.5,
    category: "Επιδόρπια",
    description: "Μπουκιές ενέργειας με χουρμάδες, κακάο και καρύδα.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },

  {
    id: "item054",
    restaurantId: "resto009",
    name: "Shrimp Saganaki",
    price: 17.5,
    category: "Ορεκτικά",
    description: "Γαρίδες σε σάλτσα ντομάτας με φέτα και μυρωδικά.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item055",
    restaurantId: "resto009",
    name: "Fisherman's Platter",
    price: 25.0,
    category: "Κυρίως",
    description: "Ποικιλία θαλασσινών: μύδια, γαρίδες, καλαμάρια και ψάρια.",
    discount: 15,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item056",
    restaurantId: "resto009",
    name: "Ouzo",
    price: 4.0,
    category: "Ποτά",
    description: "Παραδοσιακό ποτό με γλυκάνισο, ιδανικό για θαλασσινά.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item057",
    restaurantId: "resto009",
    name: "Lemon Pie",
    price: 6.0,
    category: "Επιδόρπια",
    description: "Δροσερή λεμονόπιτα με τραγανή βάση και αφράτη γέμιση.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },

  {
    id: "item058",
    restaurantId: "resto010",
    name: "Green Curry",
    price: 12.5,
    category: "Κυρίως",
    description: "Καυτερό πράσινο κάρυ με λαχανικά και γάλα καρύδας.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item059",
    restaurantId: "resto010",
    name: "Mango Sticky Rice",
    price: 6.5,
    category: "Επιδόρπια",
    description: "Γλυκό ρύζι με καρύδα και φρέσκο μάνγκο.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item060",
    restaurantId: "resto010",
    name: "Thai Iced Tea",
    price: 4.0,
    category: "Ποτά",
    description:
      "Γλυκό τσάι με γάλα και πάγο, παραδοσιακό ταϊλανδέζικο ρόφημα.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item061",
    restaurantId: "resto010",
    name: "Satay Tofu Skewers",
    price: 7.0,
    category: "Ορεκτικά",
    description: "Σουβλάκια tofu με σάλτσα φυστικιού και ασιατικά μυρωδικά.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item062",
    restaurantId: "resto006",
    name: "Κολοκυθοκεφτέδες",
    price: 6.5,
    category: "Ορεκτικά",
    description: "Τραγανοί κολοκυθοκεφτέδες με δυόσμο και φέτα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item063",
    restaurantId: "resto006",
    name: "Αρνί Κλέφτικο",
    price: 14.0,
    category: "Κυρίως",
    description: "Αργοψημένο αρνί με πατάτες σε λαδόκολλα.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item064",
    restaurantId: "resto006",
    name: "Καρυδόπιτα",
    price: 5.0,
    category: "Επιδόρπια",
    description: "Ζουμερό ελληνικό γλυκό με καρύδι και σιρόπι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item065",
    restaurantId: "resto006",
    name: "Ρετσίνα",
    price: 3.5,
    category: "Ποτά",
    description: "Παραδοσιακό λευκό κρασί με άρωμα ρητίνης.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },

  {
    id: "item066",
    restaurantId: "resto007",
    name: "Mozzarella Sticks",
    price: 5.5,
    category: "Ορεκτικά",
    description: "Τηγανητά sticks μοτσαρέλας με σάλτσα μαρινάρας.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item067",
    restaurantId: "resto007",
    name: "Hot Dog με Chilli",
    price: 7.5,
    category: "Κυρίως",
    description: "Λουκάνικο, τσίλι, τυρί και κρεμμύδι σε αφράτο ψωμάκι.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item068",
    restaurantId: "resto007",
    name: "Cookies & Cream Milkshake",
    price: 6.5,
    category: "Ποτά",
    description: "Milkshake με μπισκότα oreo και σαντιγί.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item069",
    restaurantId: "resto007",
    name: "Brownie με Παγωτό",
    price: 6.5,
    category: "Επιδόρπια",
    description: "Ζεστό brownie σοκολάτας με μπάλα βανίλιας.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },

  {
    id: "item070",
    restaurantId: "resto008",
    name: "Tofu Stir-Fry",
    price: 8.5,
    category: "Κυρίως",
    description: "Tofu με λαχανικά και σάλτσα σόγιας πάνω σε ρύζι.",
    discount: 5,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item071",
    restaurantId: "resto008",
    name: "Avocado Toast",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Ψωμί ολικής με αβοκάντο, ντοματίνια και λιναρόσπορο.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item072",
    restaurantId: "resto008",
    name: "Vegan Mocha",
    price: 4.5,
    category: "Ποτά",
    description: "Ζεστό ρόφημα σοκολάτας με καφέ και φυτικό γάλα.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item073",
    restaurantId: "resto008",
    name: "Banana Bread",
    price: 5.0,
    category: "Επιδόρπια",
    description: "Αφράτο vegan κέικ μπανάνας χωρίς ζάχαρη.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },

  {
    id: "item074",
    restaurantId: "resto009",
    name: "Stuffed Mussels",
    price: 13.5,
    category: "Ορεκτικά",
    description: "Μύδια γεμιστά με ρύζι, μυρωδικά και λεμόνι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item075",
    restaurantId: "resto009",
    name: "Grilled Sea Bream",
    price: 19.5,
    category: "Κυρίως",
    description: "Τσιπούρα σχάρας με βραστά λαχανικά και λεμονόλαδο.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item076",
    restaurantId: "resto009",
    name: "White Wine",
    price: 4.5,
    category: "Ποτά",
    description: "Δροσερό λευκό κρασί, ιδανικό για θαλασσινά.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item077",
    restaurantId: "resto009",
    name: "Κρέμα Καραμελέ",
    price: 5.5,
    category: "Επιδόρπια",
    description: "Απαλή κρέμα με καραμέλα και άρωμα βανίλιας.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },

  {
    id: "item078",
    restaurantId: "resto010",
    name: "Chicken Katsu Curry",
    price: 12.0,
    category: "Κυρίως",
    description: "Τραγανό κοτόπουλο με ιαπωνική κάρι και ρύζι.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item079",
    restaurantId: "resto010",
    name: "Edamame με Αλάτι",
    price: 4.0,
    category: "Ορεκτικά",
    description: "Αχνισμένα edamame φασόλια με θαλασσινό αλάτι.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item080",
    restaurantId: "resto010",
    name: "Bubble Tea",
    price: 5.5,
    category: "Ποτά",
    description: "Δροσερό ρόφημα τσαγιού με tapioca pearls.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item081",
    restaurantId: "resto010",
    name: "Coconut Ice Cream",
    price: 5.0,
    category: "Επιδόρπια",
    description: "Ελαφρύ παγωτό καρύδας, ιδανικό για κλείσιμο.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item082",
    restaurantId: "resto006",
    name: "Ντολμαδάκια Γιαλαντζί",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Αμπελόφυλλα γεμιστά με ρύζι και μυρωδικά.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item083",
    restaurantId: "resto006",
    name: "Σουβλάκι Χοιρινό",
    price: 9.5,
    category: "Κυρίως",
    description: "Παραδοσιακά σουβλάκια με πίτα και πατάτες.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item084",
    restaurantId: "resto006",
    name: "Λουκουμάδες με Μέλι",
    price: 5.0,
    category: "Επιδόρπια",
    description: "Τραγανοί λουκουμάδες με μέλι και κανέλα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item085",
    restaurantId: "resto006",
    name: "Τσίπουρο",
    price: 3.0,
    category: "Ποτά",
    description: "Παραδοσιακό ελληνικό απόσταγμα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item086",
    restaurantId: "resto007",
    name: "Loaded Nachos",
    price: 7.0,
    category: "Ορεκτικά",
    description: "Τορτίγια με τυρί, ντομάτα, jalapeños και sour cream.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item087",
    restaurantId: "resto007",
    name: "Double Smash Burger",
    price: 10.5,
    category: "Κυρίως",
    description: "Διπλό μπιφτέκι με cheddar και μυστική σως.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item088",
    restaurantId: "resto007",
    name: "Strawberry Shake",
    price: 6.0,
    category: "Ποτά",
    description: "Milkshake φράουλας με σαντιγί και σιρόπι.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item089",
    restaurantId: "resto007",
    name: "Cookie Sandwich",
    price: 5.5,
    category: "Επιδόρπια",
    description: "Δύο μπισκότα με παγωτό ανάμεσα.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item090",
    restaurantId: "resto008",
    name: "Falafel Bowl",
    price: 8.0,
    category: "Κυρίως",
    description: "Φαλάφελ με κινόα, hummus και σαλάτα.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item091",
    restaurantId: "resto008",
    name: "Stuffed Peppers",
    price: 7.5,
    category: "Ορεκτικά",
    description: "Γεμιστές πιπεριές με ρύζι, λαχανικά και μυρωδικά.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item092",
    restaurantId: "resto008",
    name: "Chia Pudding",
    price: 5.0,
    category: "Επιδόρπια",
    description: "Πουτίγκα chia με καρύδα και φρούτα του δάσους.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item093",
    restaurantId: "resto008",
    name: "Cold Brew Almond Latte",
    price: 4.8,
    category: "Ποτά",
    description: "Καφές φίλτρου με παγάκια και γάλα αμυγδάλου.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item094",
    restaurantId: "resto009",
    name: "Γαρίδες Σαγανάκι",
    price: 16.0,
    category: "Ορεκτικά",
    description: "Γαρίδες με φέτα, ντομάτα και ούζο σε πήλινο.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item095",
    restaurantId: "resto009",
    name: "Μπακαλιάρος Σκορδαλιά",
    price: 17.5,
    category: "Κυρίως",
    description: "Τραγανός μπακαλιάρος με παραδοσιακή σκορδαλιά.",
    discount: 5,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item096",
    restaurantId: "resto009",
    name: "Μοσχοφίλερο",
    price: 5.0,
    category: "Ποτά",
    description: "Αρωματικό ελληνικό κρασί, ιδανικό με θαλασσινά.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item097",
    restaurantId: "resto009",
    name: "Παγωτό Καϊμάκι",
    price: 4.5,
    category: "Επιδόρπια",
    description: "Παραδοσιακό παγωτό με μαστίχα και σαλέπι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item098",
    restaurantId: "resto010",
    name: "Ramen με Χοιρινό",
    price: 13.0,
    category: "Κυρίως",
    description: "Πικάντικο ramen με χοιρινό, αυγό και φύκια.",
    discount: 10,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item099",
    restaurantId: "resto010",
    name: "Kimchi Pancakes",
    price: 6.5,
    category: "Ορεκτικά",
    description: "Τηγανίτες κορεάτικες με kimchi και σως σόγιας.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item100",
    restaurantId: "resto010",
    name: "Jasmine Tea",
    price: 3.5,
    category: "Ποτά",
    description: "Αρωματικό πράσινο τσάι για χαλάρωση.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item101",
    restaurantId: "resto010",
    name: "Matcha Mochi",
    price: 4.5,
    category: "Επιδόρπια",
    description: "Ιαπωνικά γλυκάκια με γεύση matcha και μαλακή υφή.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item102",
    restaurantId: "resto006",
    name: "Σαγανάκι Τυρί",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Τηγανητό κεφαλοτύρι με λεμόνι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item103",
    restaurantId: "resto006",
    name: "Αρνί στο Φούρνο",
    price: 14.0,
    category: "Κυρίως",
    description: "Αργοψημένο αρνί με πατάτες λεμονάτες.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item104",
    restaurantId: "resto006",
    name: "Γλυκό του Κουταλιού Βύσσινο",
    price: 4.0,
    category: "Επιδόρπια",
    description: "Παραδοσιακό βύσσινο με γιαούρτι.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item105",
    restaurantId: "resto006",
    name: "Ρακόμελο",
    price: 3.5,
    category: "Ποτά",
    description: "Ζεστό ποτό με ρακή, μέλι και κανέλα.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item106",
    restaurantId: "resto007",
    name: "Mozzarella Sticks",
    price: 5.5,
    category: "Ορεκτικά",
    description: "Τηγανητά μπαστουνάκια μοτσαρέλας με σως ντομάτας.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item107",
    restaurantId: "resto007",
    name: "Spicy Chicken Burger",
    price: 9.0,
    category: "Κυρίως",
    description: "Πικάντικο φιλέτο κοτόπουλου με σως buffalo.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item108",
    restaurantId: "resto007",
    name: "Oreo Milkshake",
    price: 6.2,
    category: "Ποτά",
    description: "Milkshake με Oreo και σοκολατένια βάση.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item109",
    restaurantId: "resto007",
    name: "Brownie με Παγωτό",
    price: 5.8,
    category: "Επιδόρπια",
    description: "Ζεστό brownie με παγωτό βανίλια.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item110",
    restaurantId: "resto008",
    name: "Lentil Soup",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Βελουτέ σούπα φακής με κύμινο και καρότο.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item111",
    restaurantId: "resto008",
    name: "Zucchini Noodles",
    price: 9.0,
    category: "Κυρίως",
    description: "Νούντλς από κολοκύθι με pesto βασιλικού.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item112",
    restaurantId: "resto008",
    name: "Raw Cheesecake",
    price: 6.5,
    category: "Επιδόρπια",
    description: "Vegan cheesecake χωρίς ψήσιμο με berries.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item113",
    restaurantId: "resto008",
    name: "Green Detox Smoothie",
    price: 4.5,
    category: "Ποτά",
    description: "Smoothie με σπανάκι, μήλο και σέλινο.",
    discount: 0,
    photoUrl: "/images/mobile2.jpg",
  },
  {
    id: "item114",
    restaurantId: "resto009",
    name: "Μύδια Αχνιστά",
    price: 14.0,
    category: "Ορεκτικά",
    description: "Φρέσκα μύδια στον ατμό με σκόρδο και μαϊντανό.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item115",
    restaurantId: "resto009",
    name: "Ψαρόσουπα",
    price: 12.5,
    category: "Κυρίως",
    description: "Ζεστή σούπα με ποικιλία φρέσκων ψαριών.",
    discount: 10,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item116",
    restaurantId: "resto009",
    name: "Γρανίτα Λεμόνι",
    price: 4.0,
    category: "Επιδόρπια",
    description: "Δροσιστικό παγωμένο επιδόρπιο με χυμό λεμονιού.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item117",
    restaurantId: "resto009",
    name: "Ούζο",
    price: 3.5,
    category: "Ποτά",
    description: "Παραδοσιακό ποτό ιδανικό για θαλασσινά.",
    discount: 0,
    photoUrl: "/images/mobile3.jpg",
  },
  {
    id: "item118",
    restaurantId: "resto010",
    name: "Gyoza",
    price: 6.0,
    category: "Ορεκτικά",
    description: "Γιαπωνέζικα dumplings γεμιστά με λαχανικά.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item119",
    restaurantId: "resto010",
    name: "Katsu Chicken Curry",
    price: 11.5,
    category: "Κυρίως",
    description: "Τραγανό κοτόπουλο με ιαπωνικό κάρυ και ρύζι.",
    discount: 5,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item120",
    restaurantId: "resto010",
    name: "Mango Sticky Rice",
    price: 5.5,
    category: "Επιδόρπια",
    description: "Κολλώδες ρύζι με γάλα καρύδας και φρέσκο μάνγκο.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
  {
    id: "item121",
    restaurantId: "resto010",
    name: "Lychee Lemonade",
    price: 4.2,
    category: "Ποτά",
    description: "Λεμονάδα με γεύση λίτσι για εξωτική φρεσκάδα.",
    discount: 0,
    photoUrl: "/images/mobile1.jpg",
  },
];

export const reservations = [
  {
    id: "reservation006",
    userId: "user001",
    restaurantId: "resto007",
    date: "2024-09-15",
    time: "19:00",
    guestCount: 2,
    status: "pending",
    specialMenuId: "menu201",
    couponId: null,
  },
  {
    id: "reservation007",
    userId: "user001",
    restaurantId: "resto008",
    date: "2024-09-20",
    time: "14:00",
    guestCount: 4,
    status: "completed",
    specialMenuId: "menu202",
    couponId: null,
    notes: "Καρεκλάκι για μωρό",
  },
  {
    id: "reservation008",
    userId: "user001",
    restaurantId: "resto009",
    date: "2024-09-25",
    time: "21:00",
    guestCount: 2,
    status: "cancelled",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation009",
    userId: "user001",
    restaurantId: "resto010",
    date: "2024-09-30",
    time: "13:30",
    guestCount: 1,
    status: "approved",
    specialMenuId: null,
    couponId: "coupon004",
  },
  {
    id: "reservation010",
    userId: "user001",
    restaurantId: "resto006",
    date: "2024-10-05",
    time: "20:00",
    guestCount: 3,
    status: "completed",
    specialMenuId: "menu206",
    couponId: null,
  },
  {
    id: "reservation011",
    userId: "user001",
    restaurantId: "resto006",
    date: "2024-10-12",
    time: "13:00",
    guestCount: 2,
    status: "pending",
    specialMenuId: "menu201",
    couponId: "coupon001",
  },
  {
    id: "reservation012",
    userId: "user001",
    restaurantId: "resto006",
    date: "2024-11-03",
    time: "15:30",
    guestCount: 4,
    status: "approved",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation013",
    userId: "user001",
    restaurantId: "resto006",
    date: "2024-11-18",
    time: "12:00",
    guestCount: 1,
    status: "completed",
    specialMenuId: null,
    couponId: "coupon001",
  },

  {
    id: "reservation014",
    userId: "user001",
    restaurantId: "resto007",
    date: "2024-10-08",
    time: "19:30",
    guestCount: 2,
    status: "pending",
    specialMenuId: "menu202",
    couponId: "coupon004",
  },
  {
    id: "reservation015",
    userId: "user001",
    restaurantId: "resto007",
    date: "2024-10-20",
    time: "18:00",
    guestCount: 5,
    status: "cancelled",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation016",
    userId: "user001",
    restaurantId: "resto007",
    date: "2024-11-01",
    time: "21:00",
    guestCount: 3,
    status: "completed",
    specialMenuId: "menu202",
    couponId: null,
  },
  {
    id: "reservation017",
    userId: "user001",
    restaurantId: "resto007",
    date: "2024-11-10",
    time: "20:00",
    guestCount: 2,
    status: "approved",
    specialMenuId: null,
    couponId: "coupon001",
  },

  {
    id: "reservation018",
    userId: "user001",
    restaurantId: "resto008",
    date: "2024-10-11",
    time: "13:30",
    guestCount: 1,
    status: "completed",
    specialMenuId: "menu203",
    couponId: null,
  },
  {
    id: "reservation019",
    userId: "user001",
    restaurantId: "resto008",
    date: "2024-10-23",
    time: "17:00",
    guestCount: 2,
    status: "pending",
    specialMenuId: null,
    couponId: "coupon002",
  },
  {
    id: "reservation020",
    userId: "user001",
    restaurantId: "resto008",
    date: "2024-11-05",
    time: "14:00",
    guestCount: 3,
    status: "cancelled",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation021",
    userId: "user001",
    restaurantId: "resto008",
    date: "2024-11-19",
    time: "13:00",
    guestCount: 2,
    status: "approved",
    specialMenuId: "menu203",
    couponId: null,
  },

  {
    id: "reservation022",
    userId: "user001",
    restaurantId: "resto009",
    date: "2024-10-10",
    time: "20:30",
    guestCount: 4,
    status: "completed",
    specialMenuId: "menu204",
    couponId: null,
  },
  {
    id: "reservation023",
    userId: "user001",
    restaurantId: "resto009",
    date: "2024-10-18",
    time: "19:00",
    guestCount: 2,
    status: "pending",
    specialMenuId: null,
    couponId: "coupon003",
  },
  {
    id: "reservation024",
    userId: "user001",
    restaurantId: "resto009",
    date: "2024-11-09",
    time: "22:00",
    guestCount: 1,
    status: "completed",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation025",
    userId: "user001",
    restaurantId: "resto009",
    date: "2024-11-22",
    time: "21:30",
    guestCount: 2,
    status: "approved",
    specialMenuId: "menu204",
    couponId: "coupon003",
  },

  {
    id: "reservation026",
    userId: "user001",
    restaurantId: "resto010",
    date: "2024-10-06",
    time: "13:30",
    guestCount: 2,
    status: "completed",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation027",
    userId: "user001",
    restaurantId: "resto010",
    date: "2024-10-17",
    time: "20:00",
    guestCount: 3,
    status: "pending",
    specialMenuId: "menu205",
    couponId: null,
  },
  {
    id: "reservation028",
    userId: "user001",
    restaurantId: "resto010",
    date: "2024-11-13",
    time: "18:30",
    guestCount: 1,
    status: "cancelled",
    specialMenuId: null,
    couponId: null,
  },
  {
    id: "reservation029",
    userId: "user001",
    restaurantId: "resto010",
    date: "2024-11-25",
    time: "19:30",
    guestCount: 2,
    status: "approved",
    specialMenuId: "menu205",
    couponId: "coupon005",
  },
];

export const payments = [
  {
    id: "payment003",
    userId: "user001",
    reservationId: "reservation005",
    amount: 45.0,
    paymentMethod: "card",
    status: "completed",
  },
  {
    id: "payment004",
    userId: "user001",
    reservationId: "reservation006",
    amount: 28.0,
    paymentMethod: "paypal",
    status: "pending",
  },
  {
    id: "payment005",
    userId: "user001",
    reservationId: "reservation007",
    amount: 36.0,
    paymentMethod: "card",
    status: "completed",
  },
  {
    id: "payment006",
    userId: "user001",
    reservationId: "reservation009",
    amount: 10.0,
    paymentMethod: "card",
    status: "completed",
  },
  {
    id: "payment007",
    userId: "user001",
    reservationId: null,
    amount: 5.0,
    paymentMethod: "loyalty points",
    status: "completed",
  },
];

export const specialMenus = [
  {
    id: "menu201",
    restaurantId: "resto006",
    name: "Παραδοσιακό Γεύμα Cozy",
    description:
      "Ορεκτικό, κυρίως πιάτο και παραδοσιακό επιδόρπιο σε ειδική τιμή.",
    originalPrice: 26,
    discountedPrice: 20,
    discountPercentage: 23,
    photoUrl: "/images/mobile3.jpg",
    selectedItems: [
      { id: "item025", name: "Χωριάτικη Σαλάτα" },
      { id: "item026", name: "Μουσακάς" },
      { id: "item027", name: "Γιαούρτι με Μέλι και Καρύδια" },
    ],
    availability: {
      type: "recurring",
      daysOfWeek: ["Tuesday", "Thursday"],
      timeRange: { start: "13:00", end: "16:00" },
    },
    createdAt: "2024-06-05T00:00:00Z",
  },
  {
    id: "menu202",
    restaurantId: "resto007",
    name: "BBQ Deluxe Combo",
    description: "Δύο burgers και milkshake στην τιμή του ενός.",
    originalPrice: 24,
    discountedPrice: 17,
    discountPercentage: 29,
    photoUrl: "/images/mobile1.jpg",
    selectedItems: [
      { id: "item028", name: "Classic Cheeseburger" },
      { id: "item031", name: "BBQ Bacon Burger" },
      { id: "item030", name: "Chocolate Milkshake" },
    ],
    availability: {
      type: "permanent",
      timeRange: { start: "18:00", end: "22:00" },
    },
    createdAt: "2024-06-07T00:00:00Z",
  },
  {
    id: "menu203",
    restaurantId: "resto008",
    name: "Vegan Power Meal",
    description: "Ορεκτικό, vegan burger και σοκολατένιο γλυκό.",
    originalPrice: 22,
    discountedPrice: 17,
    discountPercentage: 22,
    photoUrl: "/images/mobile2.jpg",
    selectedItems: [
      { id: "item033", name: "Hummus with Pita" },
      { id: "item032", name: "Vegan Burger" },
      { id: "item034", name: "Vegan Chocolate Cake" },
    ],
    availability: {
      type: "recurring",
      daysOfWeek: ["Monday", "Saturday"],
      timeRange: { start: "14:00", end: "17:00" },
    },
    createdAt: "2024-06-08T00:00:00Z",
  },
  {
    id: "menu204",
    restaurantId: "resto009",
    name: "Θαλασσινό Δείπνο Δύο Ατόμων",
    description: "Ριζότο, καλαμαράκια και σαλάτα για δύο άτομα.",
    originalPrice: 42,
    discountedPrice: 33,
    discountPercentage: 21,
    photoUrl: "/images/mobile3.jpg",
    selectedItems: [
      { id: "item037", name: "Seafood Risotto" },
      { id: "item036", name: "Fried Calamari" },
      { id: "item038", name: "Greek Salad" },
    ],
    availability: {
      type: "specific",
      dates: ["2025-05-14", "2025-05-18"],
      timeRange: { start: "19:00", end: "22:00" },
    },
    createdAt: "2024-06-10T00:00:00Z",
  },
  {
    id: "menu205",
    restaurantId: "resto010",
    name: "Spicy Lover's Combo",
    description: "Σούπα, noodles και ρολάκια λαχανικών για τους τολμηρούς.",
    originalPrice: 21,
    discountedPrice: 15,
    discountPercentage: 28,
    photoUrl: "/images/mobile1.jpg",
    selectedItems: [
      { id: "item041", name: "Tom Yum Soup" },
      { id: "item039", name: "Pad Thai" },
      { id: "item040", name: "Spring Rolls" },
    ],
    availability: {
      type: "recurring",
      daysOfWeek: ["Friday", "Saturday"],
      timeRange: { start: "17:30", end: "21:30" },
    },
    createdAt: "2024-06-12T00:00:00Z",
  },
  {
    id: "menu206",
    restaurantId: "resto006",
    name: "Μεσημεριανή Προσφορά Cozy",
    description: "Δύο πιάτα με κρασί σε τιμή προσφοράς, μόνο μεσημέρι.",
    originalPrice: 30,
    discountedPrice: 23,
    discountPercentage: 23,
    photoUrl: "/images/mobile3.jpg",
    selectedItems: [
      { id: "item026", name: "Μουσακάς" },
      { id: "item025", name: "Χωριάτικη Σαλάτα" },
    ],
    availability: {
      type: "recurring",
      daysOfWeek: ["Monday", "Tuesday", "Wednesday"],
      timeRange: { start: "12:00", end: "15:00" },
    },
    createdAt: "2024-06-15T00:00:00Z",
  },
];

export const coupons = [
  {
    id: "coupon001",
    restaurantId: "resto006",
    description: "Έκπτωση 15% για κρατήσεις άνω των 3 ατόμων",
    discountPercentage: 15,
    requiredPoints: 60,
  },
  {
    id: "coupon002",
    restaurantId: "resto007",
    description: "Δωρεάν αναβάθμιση σε μεγάλη μερίδα πατάτες",
    discountPercentage: 0,
    requiredPoints: 30,
  },
  {
    id: "coupon003",
    restaurantId: "resto009",
    description: "Έκπτωση 10€ για λογαριασμούς άνω των 50€",
    discountPercentage: null,
    fixedDiscount: 10,
    requiredPoints: 80,
  },
  {
    id: "coupon004",
    restaurantId: "resto008",
    description: "Δωρεάν επιδόρπιο με κάθε κυρίως πιάτο",
    discountPercentage: 0,
    requiredPoints: 50,
  },
  {
    id: "coupon005",
    restaurantId: "resto010",
    description: "2+1 στα κυρίως πιάτα κάθε Τρίτη",
    discountPercentage: null,
    specialOffer: "buy2get1free",
    requiredPoints: 70,
  },
];
